import { render, staticRenderFns } from "./admin-app-bar.component.vue?vue&type=template&id=610e5472&scoped=true"
import script from "./admin-app-bar.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-app-bar.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-app-bar.component.vue?vue&type=style&index=0&id=610e5472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e5472",
  null
  
)

export default component.exports